// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2XvXE","options":"AnswerScale_options__3vtKa","selected":"AnswerScale_selected__2A4Cp"};